/*============================================================================
  MAPPATURA VOCI FILTRI
==============================================================================*/
const map_filtri = {
  'Cold': 'Freddi',
  'Warm': 'Caldi',
  'Neutral': 'Neutri',
  'Pastel': 'Pastello',
  'Soft Choice': 'Soft',
  'Strong Choice': 'Strong',
  'Blue': 'Blu',
  'Brown': 'Marrone',
  'Green': 'Verde',
  'Grey': 'Grigio',
  'Orange': 'Arancione',
  'Pink': 'Rosa',
  'Purple': 'Viola',
  'White': 'Bianco',
  'Yellow': 'Giallo',
  'Black': 'Nero',
  'Red': 'Rosso'
}

/*============================================================================
  Ajax Calculator
==============================================================================*/
class Calculator {

  loadCalculator() {
    // VARIABILI
    this.body = $("body");
    this.peopleQty = 1;
    this.copertura_mq = parseInt($("#copertura_mq").html());
    this.copertura_mq_4l = this.copertura_mq * 4;
    this.indexLastWallVisible = 1;
    this.calculatorContainer = $("#CartContainer");
    this.productQty4L = 0;
    this.productQty1L = 0;
    this.has1Liter = false;
    if ($("#idProduct1L").length > 0) {
      this.has1Liter = true;
    }

    $("#productQty4L").html(this.productQty4L);
    if (this.has1Liter === true) {
      $("#productQty1L").html(this.productQty1L);
    }
    this.kitQty = this.peopleQty;

    // varianti prodotto
    this.idProduct4L = $("#idProduct4L").html();
    this.idProduct1L = null;
    if (this.has1Liter === true) {
      this.idProduct1L = $("#idProduct1L").html();
    }

    // Visualizzo il loader
    this.body.addClass('drawer--is-loading');

    // Pulisco eventuale html all'interno del drwawer (esempio: html del carrello)
    this.calculatorContainer.empty();

    // Visualizzo il titolo del calcolatore
    $('.cart_drawer__title').addClass("hide");
    $('.drawer_configurator__title').removeClass("hide");

    // Butto dentro tutto l'html del calcolatore
    this.calculatorContainer.html($(".ajaxCalculator").html());

    $(".people-qty").html(this.peopleQty);

    $(".ajaxCalculator-step-1").removeClass("hide");
    $(".ajaxCalculator-step-2").addClass("hide");
    $(".div-dimensione-superficie").addClass("hide");

    // Recupero il prodotto "Essential kit" per visualizzarne le info nel drawer
    jQuery.getJSON('/products/kit-per-verniciare.js', function(product) {
      $("#name_product_kit").html(product['title']);
      // la descrizione la scrivo direttamente nella pagina per poterla tradurre tramite l'app
      // Questo perchè altrimenti, prendendola da shopify, mi tornerebbe sempre in inglese
      //$("#descr_product_kit").html(product['description']);
      $(".url_product_kit").attr("href", product['url']);
      $("#img_product_kit").attr("src", product['featured_image']);
      $("#finalPriceKit").data("price", product['price']/100);
      $("#idKit").html(product.variants[0]['id']);
    });
    this.unitPrice4L = parseInt($("#productUnitPrice4L").html())/100;
    this.unitPrice1L = 0;
    if (this.has1Liter === true) {
      this.unitPrice1L = parseInt($("#productUnitPrice1L").html())/100;
    }

    // Tolgo il loader
    this.body.removeClass('drawer--is-loading');

    // Inizializzo le varie azione
    this.addAction();
  }

  addAction() {
    $(".sub-people-qty").on('click', function() {
      this.removePeople();
    }.bind(this));

    $(".add-people-qty").on('click', function() {
      this.addPeople();
    }.bind(this));

    $(".tipo-dimensioni").on('click', function(e) {
      this.modificaTipoDimensioni($(e.target));
    }.bind(this));

    $(".tipo-dimensioni span").on('click', function(e) {
      e.stopPropagation();
      this.modificaTipoDimensioni($(e.target).parent());
    }.bind(this));

    $(".btn-add-wall").on('click', function(e) {
      this.addWall();
    }.bind(this));

    $(".btn-calculate").on('click', function(e) {
      this.calculate();
    }.bind(this));

    $(".sub-product-qty4L").on('click', function(e) {
      this.subProductQty("4L");
    }.bind(this));

    $(".sub-product-qty1L").on('click', function(e) {
      this.subProductQty("1L");
    }.bind(this));

    $(".add-product-qty4L").on('click', function(e) {
      this.addProductQty("4L");
    }.bind(this));

    $(".add-product-qty1L").on('click', function(e) {
      this.addProductQty("1L");
    }.bind(this));

    $(".sub-kit-qty").on('click', function(e) {
      this.subKitQty();
    }.bind(this));

    $(".add-kit-qty").on('click', function(e) {
      this.addKitQty();
    }.bind(this));

    $("#addAllToCart").on('click', function(e) {
      this.addAllToCart();
    }.bind(this));

  }

  isValidFloat(inputtxt) {
    var newStr = inputtxt.replace(/,/g, '.');
    var decimal = /^[-+]?[0-9]+\.?[0-9]?$/;

    if (newStr.match(decimal)) {
      return true;
    } else {
      return false;
    }
  }

  addPeople() {
    this.peopleQty = this.peopleQty + 1;
    $(".people-qty").html(this.peopleQty);
  }

  removePeople() {
    if (this.peopleQty < 2) {
      return false;
    }
    this.peopleQty = this.peopleQty - 1;
    $(".people-qty").html(this.peopleQty);
  }

  subProductQty(option_name) {
    var product_qty = this.productQty4L;
    if (option_name === '1L') {
      var product_qty = this.productQty1L;
    }

    if (product_qty < 1) {
      return false;
    }

    product_qty = product_qty - 1;

    if (option_name === '1L') {
      this.productQty1L = product_qty;
    }
    else {
      this.productQty4L = product_qty;
    }

    $("#productQty" + option_name).html(product_qty);
    this.updatePrice();
  }

  addProductQty(option_name) {
    var product_qty = this.productQty4L;
    if (option_name === '1L') {
      var product_qty = this.productQty1L;
    }

    product_qty = product_qty + 1;

    if (option_name === '1L') {
      this.productQty1L = product_qty;
    }
    else {
      this.productQty4L = product_qty;
    }

    $("#productQty" + option_name).html(product_qty);
    this.updatePrice();
  }

  subKitQty() {
    if (this.kitQty < 1) {
      return false;
    }
    this.kitQty = this.kitQty - 1;
    $("#kitQty").html(this.kitQty);
    this.updatePrice();
  }

  addKitQty() {
    this.kitQty = this.kitQty + 1;
    $("#kitQty").html(this.kitQty);
    this.updatePrice();
  }

  addAllToCart() {
    var idProduct4L = $("#idProduct4L").html();
    var idKit = $("#idKit").html();

    let formData = {
      'items': [{
        'id': idProduct4L,
        'quantity': this.productQty4L
      },{
        'id': idKit,
        'quantity': this.kitQty
      }]
    };

    if (this.has1Liter === true) {
      var idProduct1L = $("#idProduct1L").html();
      formData['items'].push({'id': idProduct1L, 'quantity': this.productQty1L})
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(formData)
    })
      .then(response => response.json())
      .then(cart => {
        $(".js-drawer-open-button-right").trigger('click');
        //theme.cache.$body.trigger('ajaxCart.afterCartLoad', cart);
        return cart;
      })
      .catch((error) => {
        console.error('Error:', error);
      });

  }

  modificaTipoDimensioni(elem) {
    var tipo_dimensione = elem.data('dimensione');
    $(".tipo-dimensioni").removeClass("active");
    elem.addClass("active");

    $(".div-dimensione-superficie").addClass("hide");
    $(".dimensione-" + tipo_dimensione).removeClass("hide");
    $(".ajaxcart__footer-step1").removeClass("hide");
  }

  addWall() {
    // visualizzo il successivo div del wall
    this.indexLastWallVisible = this.indexLastWallVisible + 1;
    $(".div-single-wall-"+this.indexLastWallVisible).removeClass("hide");
  }

  showError(elem_id) {
    console.log("mostro errore : " + elem_id);
    $(elem_id + "_errormessage").removeClass("hide");
  }

  cleanAllErrors() {
    $("#id_input_m2errormessage").addClass("hide");
  }

  calculate() {
    this.cleanAllErrors();
    var m2_totali = 0;

    // controllo in che casistica sono
    if ($(".dimensione-area-superficie").hasClass('hide') === true) {
        var show_errors = false;

        for (var x=1; x<=7; x++) {
            var length = $("#id_wall_length_" + x).val();
            var height = $("#id_wall_height_" + x).val();

            if (length != '' && height != '') {
                // controllo length
                if (!this.isValidFloat(length)) {
                    this.showError("#id_wall_length_" + x);
                    show_errors = true;
                    continue;
                }
                // controllo height
                if (!this.isValidFloat(height)) {
                    this.showError("#id_wall_height_" + x);
                    show_errors = true;
                    continue;
                }

                m2_totali += parseFloat(length) * parseFloat(height);
            }
        }

        if (isNaN(m2_totali) || m2_totali < 1) {
            return;
        }

        if (show_errors === true) {
            return;
        }
    } else {
        var m2 = $("#id_input_m2").val();
        if (m2 == '' || !this.isValidFloat(m2)) {
            this.showError("#id_input_m2");
            return;
        }

        // caso m2 direttamente inseriti
        m2_totali = parseFloat(m2.replace(/,/g, '.'));
    }
    $(".ajaxCalculator-step-1").addClass("hide");
    $(".ajaxCalculator-step-2").removeClass("hide");

    // calcolo della quantità di prodotto necessaria
    if (this.has1Liter === true) {
        // calcolo quantità di prodotto da 4 litri
        this.productQty4L = Math.floor(m2_totali / this.copertura_mq_4l);
        const m2_rimanenti = m2_totali - (this.copertura_mq_4l * this.productQty4L);

        // calcolo quantità di prodotto da 1 litro
        this.productQty1L = Math.ceil(m2_rimanenti / this.copertura_mq);

        // se la quantità di prodotto da 1 litro è esattamente 4, aggiusta la quantità di prodotto da 4 litri
        if (this.productQty1L === 4) {
            this.productQty4L += 1;
            this.productQty1L = 0;
        }
    } else {
        // calcolo quantità di prodotto da 4 litri
        this.productQty4L = Math.ceil(m2_totali / this.copertura_mq_4l);
    }

    // imposta la quantità del kit
    this.kitQty = this.peopleQty;
    $("#kitQty").html(this.kitQty);

    // visualizza la quantità di prodotto calcolata
    if (this.productQty4L > 0) {
        $("#productQty4L").html(this.productQty4L);
    } else {
        $("#ajaxcartRow4L").hide()
    }

    if (this.productQty1L > 0) {
        $("#productQty1L").html(this.productQty1L);
    } else {
        $("#ajaxcartRow1L").hide()
    }

    // aggiorna i prezzi
    this.updatePrice();
}

  updatePrice() {
    $("#finalPriceProduct4L").html("€ " + this.unitPrice4L * this.productQty4L);
    if (this.has1Liter === true) {
      $("#finalPriceProduct1L").html("€ " + this.unitPrice1L * this.productQty1L);
    }
    $("#finalPriceKit").html("€ " + $("#finalPriceKit").data("price") * this.kitQty);
  }
}

function accordion() {
    var accItem = document.getElementsByClassName('accordionItem');
    var accHD = document.getElementsByClassName('accordionItemHeading');
    for (i = 0; i < accHD.length; i++) {
        accHD[i].addEventListener('click', toggleItem, false);
    }

    function toggleItem() {
        var itemClass = this.parentNode.className;

        for (i = 0; i < accItem.length; i++) {
          if ($(this.parentNode).data("accordion-multiple") == undefined) {
			      accItem[i].className = 'accordionItem accordionClose';
          } else {
            if ($(this.parentNode).hasClass("accordionOpen") && $(this.parentNode).attr("id") === $(accItem[i]).attr("id")) {
              accItem[i].className = 'accordionItem accordionClose';
            }
          }
        }
        if (itemClass == 'accordionItem accordionClose') {
            this.parentNode.className = 'accordionItem accordionOpen';
            var image = $(this).data('image');
            $(".accordion_image").addClass("hide");
            $(".accordion_image_" + image).removeClass("hide");
        }
        $(".accordionItemHeading").trigger('toogledItem');
    }
}

function changeHeader() {
    if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
        $(".header-wrapper").removeClass("header-wrapper--transparent");
        $(".header-wrapper").addClass("header-wrapper--scoll");
    } else {
        $(".header-wrapper").addClass("header-wrapper--transparent");
        $(".header-wrapper").removeClass("header-wrapper--scoll");
    }
}

function setGlider() {
    $(window).on('load', function() {
        if ($('.glider').length) {
            new Glider(document.querySelector('.glider'), {
                slidesToShow: 'auto',
                itemWidth: 310,
                exactWidth: 310,
                draggable: true,
                arrows: {
                    prev: '.glider-left-arrow',
                    next: '.glider-right-arrow'
                }
            })
        }
    });
}

function setPaintMenu() {
    $(".header-wrapper").on('mouseover', function() {
      $(".header-wrapper.header-fixed:not(.header-wrapper--scoll)").addClass("header-wrapper--paint-menu-open");
    }).on('mouseout', function() {
       $(".header-wrapper.header-fixed:not(.header-wrapper--scoll)").removeClass("header-wrapper--paint-menu-open");
    });
    $(".paint-nav-item").on('mouseover', function() {
        $("#paint-submenu").show();
        // $(".header-wrapper.header-fixed").addClass("header-wrapper--paint-menu-open");
    }).on('mouseout', function() {
        $("#paint-submenu").hide();
        // $(".header-wrapper.header-fixed").removeClass("header-wrapper--paint-menu-open");
    });
    $("#paint-submenu").on('mouseover', function() {
        $("#paint-submenu").show();
        // $(".header-wrapper.header-fixed").addClass("header-wrapper--paint-menu-open");
    }).on('mouseout', function() {
        $("#paint-submenu").hide();
        // $(".header-wrapper.header-fixed").removeClass("header-wrapper--paint-menu-open");
    });
}

function manageChangeVariant() {
    // $('#ProductSection--product-template').on('variantChange', function(evt){
    // });
    $(".custom-product-select").on('change', function() {
      window.location = $(this).val();
    })
}
  
function manageSample() {
  $(".btn--add-sample-to-cart").on('click', function() {
    // https://shopify.dev/docs/themes/ajax-api/reference/product
    var sample_handle = $(this).data('sample-handle');
    jQuery.getJSON('/products/'+ sample_handle +'.js', function(product) {
      
		let formData = {
			'items': [{
 				'id': product.variants[0].id,
				'quantity': 1
			}]
		};

		fetch('/cart/add.js', {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(formData)
        })
		.then(response => response.json())
		.then(cart => {
          	$(".js-drawer-open-button-right").trigger('click');
  			//theme.cache.$body.trigger('ajaxCart.afterCartLoad', cart);
  			return cart;
        })
		.catch((error) => {
  			console.error('Error:', error);
		}); 
    });
  });
}

function openConfigurator() {
  const calculator = new Calculator();
  calculator.loadCalculator();
}

function drawerConfigurator() {
    timber.ConfiguratorDrawer = new timber.Drawers('CartDrawer', 'right', {
        open: '.js-configurator-drawer-open-button-right',
        onDrawerOpen: openConfigurator
    });

    // $(".open-configurator").on('click', function () {
    //     $('.page-container').addClass('is-transitioning');
    //     $('body, html').addClass('js-drawer-open-right');
    //     document.getElementById("DrawerConfigurator").style.width = "250px";
    //     document.getElementById("PageContainer").style.marginRight = "250px";
    //     document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    // })
    //
    // function closeNav() {
    //     document.getElementById("DrawerConfigurator").style.width = "0";
    //     document.getElementById("PageContainer").style.marginRight = "0";
    //     document.body.style.backgroundColor = "white";
    // }
}

function addFinituraFilter() {
  // Se dovessero modificare qualcosa nell'app dei filtri e sparisce di nuovo il blocco PRODUCTS, basta andare
  // in snippets/globo.filter.tree.liquid e aggiungere l'include di 'filter-finitura', così:
  // <div class="gf-filter-contents">
  // {% endraw %}{% include 'filter-finitura' %}{% raw %}
  // {% if filters %}
  //
  var checkExistProduct = setInterval(function() {
     if ($('.collection-product-list .spf-product-card__inner .spf-product-card__image-wrapper').length) {

       if ($("#gf-products > div").length >= 32) {
        $("#blocco_inner_ricerca").insertAfter($("#gf-products > div:nth-child(12)"));
        $("#blocco_inner_ricerca").show();
       };

       clearInterval(checkExistProduct);
     }
  }, 100); // check every 100ms
}

function fixFilterTranslation() {
  var checkExistFilter = setInterval(function() {
  // Se dovessero modificare qualcosa nell'app dei filtri e spariscono di nuovo le traduzioni, basta andare
  // in snippets/globo.filter.tree.liquid e aggiungere la classe translatable a tutte le .gf-label
  //

     if ($('#gf-tree .gf-filter-contents .gf-block-content .gf-option-box .gf-label.translatable').length) {
       if (Shopify.locale === 'it') {
         $(".gf-label.translatable").each(function(index) {
           var s = $(this).html();
           if (s in map_filtri) {
             $(this).html(map_filtri[s]);
           }
         });
       }
       clearInterval(checkExistFilter);
     }
  }, 100); // check every 100ms
}

function cartUpsell() {
  var cart_header = $("#CartDrawer .drawer__fixed-header");
  console.log(cart_header);
  let cartContents = fetch('/cart.js', { method: 'GET' })
    .then(response => response.json())
    .then(data => {
      let cart_total = data.total_price / 100; // Convertiamo il prezzo in centesimi in euro
      let currency = data.currency;
      let total_miss = 100 - cart_total; // Soglia per la spedizione gratuita

      // Controlliamo se il totale del carrello è tra 30€ e 100€
      if (cart_total > 30 && cart_total < 100) {
        $(".cartUpsellFreeShippingLeft").html(total_miss.toFixed(2) + " " + currency); // toFixed(2) per mostrare due decimali
        $(".cartUpsellFreeShipping").removeClass("hide");
        $("#CartDrawer .drawer__inner").addClass("with_cart_upsell");
      } else {
        $(".cartUpsellFreeShipping").addClass("hide");
        $("#CartDrawer .drawer__inner").removeClass("with_cart_upsell");
      }
    });
}

// Listen for the event.
document.addEventListener('qview-grid-updated', function (e) {
	fixFilterTranslation();
}, false);

$(document).ready(function () {
    // When the user scrolls down 50px from the top of the document, resize the header's font size
    window.onscroll = function () {
        changeHeader()
    };

    setPaintMenu();
    setGlider();
    accordion();
    addFinituraFilter();
    fixFilterTranslation();
    manageChangeVariant();
  	manageSample();
    drawerConfigurator();
    cartUpsell();
    setInterval(() => {cartUpsell()}, 5000);
    $('.marquee').marquee();
})
